import { useRecoilState } from "recoil";
import { useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import { info as myInfo } from "../../store/my";
import { project as portfolioProject } from "../../store/portfolio";

export default function Home() {

    const [useMyInfo, setMyInfo] = useRecoilState(myInfo);
    const [usePortfolioProject, setPortfolioProject] = useRecoilState(portfolioProject);

    return (
        <div>
            <div className="section home-hero wf-section">
                <div className="container-default w-container">
                    <div className="home-hero-wrapper">
                        <div className="split-content home-hero-left">
                            <h1 style={{ fontSize: '64px' }}>Hello, I'm Duy Anh</h1>
                            <p style={{ fontSize: '20px', marginTop: '20px', marginBottom: '15px', color: '#666', lineHeight: '1.6' }}>
                                Product Builder and Full Stack Developer turning ideas into reality
                            </p>
                            <p style={{ fontSize: '16px', marginBottom: '10px', color: '#999', lineHeight: '1.8' }}>
                                Stack: Golang, Python, Java, NextJS, Flutter, CI/CD
                            </p>
                            <p style={{ fontSize: '16px', marginBottom: '30px', color: '#999', lineHeight: '1.8' }}>
                                Creator of <a href="https://kickey.net" target={'_blank'} style={{ color: '#999' }}>Kickey</a> (100K+ users), currently building <a href="https://seedstage.vn" style={{ color: '#999' }} target={'_blank'}>SeedStage</a> - a comprehensive financial tool for creators
                            </p>
                            <a href={useMyInfo.socialNetwork[useMyInfo.contactSocialNetwork]} target={'_blank'}
                                className="link-primary w-inline-block">
                                <div className="link-primary-wrapper">
                                    <div className="link-primary-text">Contact me
                                        on {useMyInfo.contactSocialNetwork}</div>
                                    <div className="link-primary-text-arrow"><span
                                        className="link-primary-arrow"></span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="split-content home-hero-right"><img
                            src="https://avatars.githubusercontent.com/u/14250512?v=4" className="image home-hero" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-default w-container">
                <div className="divider"></div>
            </div>

            <div className="container-default w-container">
                <div className="divider"></div>
            </div>
            <div className="section wf-section">
                <div className="container-default w-container">
                    <div className="top-content portfolio-section">
                        <div className="split-content portfolio-section-left">
                            <h2 className="title portfolio-section">Portfolio</h2>
                        </div>
                        <div className="split-content portfolio-section-right">
                            <Link to="/portfolio"
                                className="link-primary w-inline-block">
                                <div className="link-primary-wrapper">
                                    <div className="link-primary-text">View portfolio</div>
                                    <div className="link-primary-text-arrow"><span
                                        className="link-primary-arrow"></span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="w-dyn-list">
                        {/* Desktop Masonry - Split Columns for Ordered Look */}
                        <div className="desktop-masonry w-hidden-medium w-hidden-small w-hidden-tiny" style={{ display: 'flex', gap: '40px' }}>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '40px' }}>
                                {
                                    Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).filter((_, i) => i % 2 === 0).map(item => (
                                        <div role="listitem" className="w-dyn-item" key={item}>
                                            <Link to={'/project/' + item}
                                                className="card portfolio-project w-inline-block" style={{ marginBottom: 0 }}>
                                                <div className="image-wrapper portfolio-project"><img
                                                    src={usePortfolioProject[item].logo}
                                                    alt="" className="image portfolio-project" />
                                                </div>
                                                <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                                <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                                <p>{usePortfolioProject[item].description}</p>
                                            </Link>
                                        </div>
                                    ))
                                }
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '40px' }}>
                                {
                                    Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).filter((_, i) => i % 2 !== 0).map(item => (
                                        <div role="listitem" className="w-dyn-item" key={item}>
                                            <Link to={'/project/' + item}
                                                className="card portfolio-project w-inline-block" style={{ marginBottom: 0 }}>
                                                <div className="image-wrapper portfolio-project"><img
                                                    src={usePortfolioProject[item].logo}
                                                    alt="" className="image portfolio-project" />
                                                </div>
                                                <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                                <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                                <p>{usePortfolioProject[item].description}</p>
                                            </Link>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        {/* Mobile List - Standard Grid/List */}
                        <div role="list" className="portfolio-grid w-dyn-items w-hidden-main">
                            {
                                Object.keys(usePortfolioProject).filter((i, index) => (index < 5)).map(item => (
                                    <div role="listitem" className="w-dyn-item" key={item}>
                                        <Link to={'/project/' + item}
                                            className="card portfolio-project w-inline-block">
                                            <div className="image-wrapper portfolio-project"><img
                                                src={usePortfolioProject[item].logo}
                                                alt="" className="image portfolio-project" />
                                            </div>
                                            <div className="card-portfolio-project-client">{usePortfolioProject[item].name}</div>
                                            <h3 className="title card-portfolio-project">{usePortfolioProject[item].position}</h3>
                                            <p>{usePortfolioProject[item].description}</p>
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-default w-container">
                <div className="divider"></div>
            </div>

            <div className="section wf-section">
                <div className="container-default w-container"><h2 className="title social-profiles">Follow me on social
                    network</h2>
                    <div className="w-layout-grid social-profiles-grid">
                        {
                            Object.keys(useMyInfo.socialNetwork).map(name => (
                                <a href={useMyInfo.socialNetwork[name]}
                                    target="_blank" className="link-primary w-inline-block">
                                    <div className="link-primary-wrapper">
                                        <div className="link-primary-text">{name}</div>
                                        <div className="link-primary-text-arrow"><span
                                            className="link-primary-arrow"></span></div>
                                    </div>
                                </a>
                            ))
                        }
                    </div>
                </div>
            </div>

        </div>
    );
}